import { render } from "./InfoAlert.vue?vue&type=template&id=2ed4323a&scoped=true"
import script from "./InfoAlert.vue?vue&type=script&lang=js"
export * from "./InfoAlert.vue?vue&type=script&lang=js"

import "./InfoAlert.vue?vue&type=style&index=0&id=2ed4323a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed4323a"]])

export default __exports__